import { useMutation } from '@tanstack/react-query'
import { useAuth } from 'src/contexts/auth'
import { CouplePlanningController } from 'src/controllers/couple-planning.controller'
import { UpdateCouplePlanningDto } from 'src/dto/couple-planning.dto'

const couplePlanningController = new CouplePlanningController()

export function useUpdateCouplePlanning() {
  const { userFarm: farmId } = useAuth()

  return useMutation({
    mutationKey: ['updateCouplePlanning'],
    mutationFn: (couplePlanningDto: UpdateCouplePlanningDto) =>
      couplePlanningController.updateCouplePlanning(farmId!, couplePlanningDto)
  })
}
